var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8125 2.1875C1.2592 2.1875 9.11271e-09 3.4467 9.11271e-09 5L0 14C0 15.5533 1.2592 16.8125 2.8125 16.8125H15.1875C16.7408 16.8125 18 15.5533 18 14V5C18 3.4467 16.7408 2.1875 15.1875 2.1875H2.8125ZM15.1875 3.875H2.8125L8.68375 8.90756C8.78546 8.99802 8.93769 8.9994 9.041 8.9108L15.1875 3.875ZM1.6875 14V5L7.60084 10.1436C8.31282 10.7768 9.37848 10.7864 10.1017 10.1662L16.3125 5V14C16.3125 14.6213 15.8088 15.125 15.1875 15.125H2.8125C2.19118 15.125 1.6875 14.6213 1.6875 14Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9ede3b77312d8e25faae9f8dd0466936.svg";
export { ForwardRef as ReactComponent };